// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/deliverability/postmaster/:app_group_id/ip_reputation" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";

import { deliverabilityPostmasterAppGroupIdIpReputation } from "./constants";
import type {
  DeliverabilityPostmasterAppGroupIdIpReputationParams,
  DeliverabilityPostmasterAppGroupIdIpReputationResult,
} from "./types";

export const getDataTableDeliverabilityPostmasterAppGroupIdIpReputation = reactQueryTableFetcherAdapter(
  deliverabilityPostmasterAppGroupIdIpReputation,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query,
      groupby,
      limit = 20,
      start = 0,
      sortby,
      sortdir,
    }: DeliverabilityPostmasterAppGroupIdIpReputationParams
  ): Promise<DeliverabilityPostmasterAppGroupIdIpReputationResult> => {
    return fetch(
      `/deliverability/postmaster/${appGroupId}/ip_reputation`,
      "GET",
      {
        groupby,
        query: serializeQueryObjects(query),
        limit,
        start,
        start_date: query?.start_date,
        end_date: query?.end_date,
        app_group_id: appGroupId,
        sortby,
        sortdir,
      },
      { signal },
      { propagateFetchRequestError: false }
    );
  }
);
